import {useEffect} from "react";
import {css} from "@emotion/react";

import {CenterBox} from "@pg-design/grid";
import {calculateRemSize, mv, ph} from "@pg-design/helpers-css-strings";
import {BrandCheckboxCheckedIcon} from "@pg-design/icons-module";
import {Loader} from "@pg-design/loader-module";
import {getThemeBreakpoint, getThemeVariable} from "@pg-design/styles-strings";
import {Text} from "@pg-design/text-module";

import {ALLOWED_CITIES_FOR_REGIONS_SELECTION_ON_MAP} from "../../../offer/map/constants/allowed_cities_for_regions_selection_on_map";
import {useGetRegionDetailListQuery} from "../../../region/api/get_region_detail_list";
import {useAppDispatch, useAppSelector} from "../../../store/hooks";
import {AdditionalCriteriaFieldsNames, CriteriaFieldsNames, RegionFieldsNames, UserFieldsNames} from "../../constants/forms_fields_names";
import {useDefaultForYouValues} from "../../hooks/use_default_for_you_values";
import {forYouModalNextStep, setForYouModalLoading} from "../../state/for_you_modal_slice";
import {ForYouModalStep} from "../../types/ForYouModalStep";
import {ForYouAdditionalForm} from "../modal_forms/ForYouAdditionalForm";
import {ForYouCriteriaForm} from "../modal_forms/ForYouCriteriaForm";
import {ForYouFormsProvider} from "../modal_forms/ForYouFormsProvider";
import {ForYouRegionForm} from "../modal_forms/ForYouRegionForm";
import {ForYouUserForm} from "../modal_forms/ForYouUserForm";
import {ForYouModalButton} from "./ForYouModalButton";
import {ForYouModalSummary} from "./ForYouModalSummary";

export const ForYouModalContent = () => {
    const modalState = useAppSelector((state) => state.forYouModal);
    const {step, isLoading} = modalState;
    const dispatch = useAppDispatch();
    const {data: availableRegions, isLoading: regionsLoading} = useGetRegionDetailListQuery({
        regionIds: ALLOWED_CITIES_FOR_REGIONS_SELECTION_ON_MAP as number[]
    });

    const skipLoading = [ForYouModalStep.ADDITIONAL, ForYouModalStep.SUMMARY, ForYouModalStep.SUCCESS].includes(step);

    useEffect(() => {
        if (isLoading) {
            setTimeout(() => {
                dispatch(setForYouModalLoading(false));
            }, 1000);
        }
        if (step === ForYouModalStep.SUCCESS) {
            setTimeout(() => {
                onNextStep();
            }, 2500);
        }
    }, [step]);

    const onNextStep = () => {
        const nextStep = step + 1;

        if (!skipLoading) {
            dispatch(setForYouModalLoading(true));
        }

        dispatch(forYouModalNextStep(nextStep));
    };

    const defaultValues = useDefaultForYouValues(availableRegions);

    const renderContent = () => {
        switch (step) {
            case ForYouModalStep.SUCCESS:
                return (
                    <CenterBox css={successBox}>
                        <BrandCheckboxCheckedIcon size="9.6" wrapperSize="9.6" wrapperColor={getThemeVariable("colors.primary")} />
                        <Text variant="headline_3" as="p" style={{marginTop: calculateRemSize(3)}}>
                            Zgłoszenie wysłane!
                        </Text>
                    </CenterBox>
                );
            case ForYouModalStep.REGION:
                return (
                    <ForYouFormsProvider names={RegionFieldsNames} defaultValues={defaultValues}>
                        {(submitHandler) => <ForYouRegionForm submitHandler={submitHandler} onNextStep={onNextStep} availableRegions={availableRegions} />}
                    </ForYouFormsProvider>
                );
            case ForYouModalStep.CRITERIA:
                return (
                    <ForYouFormsProvider names={CriteriaFieldsNames} defaultValues={defaultValues}>
                        {(submitHandler, onChange) => <ForYouCriteriaForm submitHandler={submitHandler} onNextStep={onNextStep} onChange={onChange} />}
                    </ForYouFormsProvider>
                );
            case ForYouModalStep.USER:
                return (
                    <ForYouFormsProvider names={UserFieldsNames} defaultValues={defaultValues}>
                        {(submitHandler, _, onSubmitError) => (
                            <ForYouUserForm submitHandler={submitHandler} onSubmitError={onSubmitError} onNextStep={onNextStep} />
                        )}
                    </ForYouFormsProvider>
                );
            case ForYouModalStep.ADDITIONAL:
                return (
                    <ForYouFormsProvider names={AdditionalCriteriaFieldsNames} defaultValues={defaultValues}>
                        {(submitHandler, _, onSubmitError) => (
                            <ForYouAdditionalForm submitHandler={submitHandler} onSubmitError={onSubmitError} onNextStep={onNextStep} />
                        )}
                    </ForYouFormsProvider>
                );
            case ForYouModalStep.SUMMARY:
                return <ForYouModalSummary />;
            default:
                return (
                    <div>
                        <Text variant="headline_3">{step}</Text>
                    </div>
                );
        }
    };

    return (
        <div css={contentWrapper}>
            {isLoading || regionsLoading ? (
                <CenterBox className="loader-wrapper">
                    <Loader size="xl" />
                    <ForYouModalButton isPlaceholder isDisabled showStep />
                </CenterBox>
            ) : (
                renderContent()
            )}
        </div>
    );
};

const contentWrapper = css`
    height: 100%;
    display: flex;
    justify-content: start;
    align-items: center;
    flex-direction: column;
    background-color: #fff;

    .loader-wrapper {
        width: 100%;
        ${ph(3)};
    }

    @media (min-width: ${getThemeBreakpoint().md}) {
        width: 100%;
        min-height: 450px;
        background-color: ${getThemeVariable("colors.gray.100")};
    }
`;

const successBox = css`
    @media (min-width: ${getThemeBreakpoint().sm}) {
        ${mv(8)};
    }
`;
import {useEffect} from "react";
import {css} from "@emotion/react";

import {CenterBox} from "@pg-design/grid";
import {calculateRemSize, mv, ph} from "@pg-design/helpers-css-strings";
import {BrandCheckboxCheckedIcon} from "@pg-design/icons-module";
import {Loader} from "@pg-design/loader-module";
import {getThemeBreakpoint, getThemeVariable} from "@pg-design/styles-strings";
import {Text} from "@pg-design/text-module";

import {ALLOWED_CITIES_FOR_REGIONS_SELECTION_ON_MAP} from "../../../offer/map/constants/allowed_cities_for_regions_selection_on_map";
import {useGetRegionDetailListQuery} from "../../../region/api/get_region_detail_list";
import {useAppDispatch, useAppSelector} from "../../../store/hooks";
import {AdditionalCriteriaFieldsNames, CriteriaFieldsNames, RegionFieldsNames, UserFieldsNames} from "../../constants/forms_fields_names";
import {useDefaultForYouValues} from "../../hooks/use_default_for_you_values";
import {forYouModalNextStep, setForYouModalLoading} from "../../state/for_you_modal_slice";
import {ForYouModalStep} from "../../types/ForYouModalStep";
import {ForYouAdditionalForm} from "../modal_forms/ForYouAdditionalForm";
import {ForYouCriteriaForm} from "../modal_forms/ForYouCriteriaForm";
import {ForYouFormsProvider} from "../modal_forms/ForYouFormsProvider";
import {ForYouRegionForm} from "../modal_forms/ForYouRegionForm";
import {ForYouUserForm} from "../modal_forms/ForYouUserForm";
import {ForYouModalButton} from "./ForYouModalButton";
import {ForYouModalSummary} from "./ForYouModalSummary";

export const ForYouModalContent = () => {
    const modalState = useAppSelector((state) => state.forYouModal);
    const {step, isLoading} = modalState;
    const dispatch = useAppDispatch();
    const {data: availableRegions, isLoading: regionsLoading} = useGetRegionDetailListQuery({
        regionIds: ALLOWED_CITIES_FOR_REGIONS_SELECTION_ON_MAP as number[]
    });

    const skipLoading = [ForYouModalStep.ADDITIONAL, ForYouModalStep.SUMMARY, ForYouModalStep.SUCCESS].includes(step);

    useEffect(() => {
        if (isLoading) {
            setTimeout(() => {
                dispatch(setForYouModalLoading(false));
            }, 1000);
        }
        if (step === ForYouModalStep.SUCCESS) {
            setTimeout(() => {
                onNextStep();
            }, 2500);
        }
    }, [step]);

    const onNextStep = () => {
        const nextStep = step + 1;

        if (!skipLoading) {
            dispatch(setForYouModalLoading(true));
        }

        dispatch(forYouModalNextStep(nextStep));
    };

    const defaultValues = useDefaultForYouValues(availableRegions);

    const renderContent = () => {
        switch (step) {
            case ForYouModalStep.SUCCESS:
                return (
                    <CenterBox css={successBox}>
                        <BrandCheckboxCheckedIcon size="9.6" wrapperSize="9.6" wrapperColor={getThemeVariable("colors.primary")} />
                        <Text variant="headline_3" as="p" style={{marginTop: calculateRemSize(3)}}>
                            Zgłoszenie wysłane!
                        </Text>
                    </CenterBox>
                );
            case ForYouModalStep.REGION:
                return (
                    <ForYouFormsProvider names={RegionFieldsNames} defaultValues={defaultValues}>
                        {(submitHandler) => <ForYouRegionForm submitHandler={submitHandler} onNextStep={onNextStep} availableRegions={availableRegions} />}
                    </ForYouFormsProvider>
                );
            case ForYouModalStep.CRITERIA:
                return (
                    <ForYouFormsProvider names={CriteriaFieldsNames} defaultValues={defaultValues}>
                        {(submitHandler, onChange) => <ForYouCriteriaForm submitHandler={submitHandler} onNextStep={onNextStep} onChange={onChange} />}
                    </ForYouFormsProvider>
                );
            case ForYouModalStep.USER:
                return (
                    <ForYouFormsProvider names={UserFieldsNames} defaultValues={defaultValues}>
                        {(submitHandler, _, onSubmitError) => (
                            <ForYouUserForm submitHandler={submitHandler} onSubmitError={onSubmitError} onNextStep={onNextStep} />
                        )}
                    </ForYouFormsProvider>
                );
            case ForYouModalStep.ADDITIONAL:
                return (
                    <ForYouFormsProvider names={AdditionalCriteriaFieldsNames} defaultValues={defaultValues}>
                        {(submitHandler, _, onSubmitError) => (
                            <ForYouAdditionalForm submitHandler={submitHandler} onSubmitError={onSubmitError} onNextStep={onNextStep} />
                        )}
                    </ForYouFormsProvider>
                );
            case ForYouModalStep.SUMMARY:
                return <ForYouModalSummary />;
            default:
                return (
                    <div>
                        <Text variant="headline_3">{step}</Text>
                    </div>
                );
        }
    };

    return (
        <div css={contentWrapper}>
            {isLoading || regionsLoading ? (
                <CenterBox className="loader-wrapper">
                    <Loader size="xl" />
                    <ForYouModalButton isPlaceholder isDisabled showStep />
                </CenterBox>
            ) : (
                renderContent()
            )}
        </div>
    );
};

const contentWrapper = css`
    height: 100%;
    display: flex;
    justify-content: start;
    align-items: center;
    flex-direction: column;
    background-color: #fff;

    .loader-wrapper {
        width: 100%;
        ${ph(3)};
    }

    @media (min-width: ${getThemeBreakpoint().md}) {
        width: 100%;
        min-height: 450px;
        background-color: ${getThemeVariable("colors.gray.100")};
    }
`;

const successBox = css`
    @media (min-width: ${getThemeBreakpoint().sm}) {
        ${mv(8)};
    }
`;
